import { useEffect, useState } from 'react'
import { BASE_URL } from '../constants/urls';
import axios from 'axios';

const useStoreCategoryData = ({slug}) => {

    const [categorie, setcategorie] = useState({});
    const [loadingCategorie, setLoadingCategorie] = useState(true);
    const [errorCategorie, setErrorCategorie] = useState(null);

    useEffect(() => {

        const getStoreCategoryData = async () => {
            try {
                const res = await axios.get(`${BASE_URL}/store-category`, {
                    params: { slug },
                    headers: { Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`}
                  }); 

                  setcategorie(res.data)
                  
            } catch (err)  {
                const msg = err?.response?.data?.message || err.message || 'Erro desconhecido';
                setErrorCategorie(msg);
            } finally {
              setLoadingCategorie(false)
            }
        }

        getStoreCategoryData();

    }, [slug])
  

   return { categorie, loadingCategorie, errorCategorie };
}

export default useStoreCategoryData